import React, { Component, Fragment } from 'react';

/* ================= STATIC IMPORTS (A to Z) ================= */

// HERO & STATIC BANNERS
import IMG_CONNECT from '../../images/images/CONNECT_Mesa de trabajo 1.jpg';


// SHOP GRID
import IMG_SOCCER_NEO from '../../images/images/dafe4ref.JPG';
import IMG_CRICKET_POWERPLAY from '../../images/images/adfdf.JPG';
import IMG_BASKETBALL_ELEVATE from '../../images/images/fefdfeaf.JPG';
import IMG_GOALKEEPER_VOLT from '../../images/images/dsafeefd.JPG';

// GALLERY
import GAL_IMG_1 from '../../images/images/1f64bd8b160328621fe9bccc1679aa4db8a3045f-4064x2287.jpg';
import GAL_IMG_2 from '../../images/images/83-USA-squad-victory-photo-in-front-of-pavilion-3-600x403.jpg';
import GAL_IMG_3 from '../../images/images/07-25-2022-sault-united-u14-girls-team-captures-usa-cup-in-minnesota-af-03.jpg';
import GAL_IMG_4 from '../../images/images/image-placeholder-title.jpg';

// VIDEOS (keep static as requested)
// If you rename the file to final-render.mp4, update the import accordingly.
// import VIDEO_HERO from '../../images/videos/final-render.mp4';
import VIDEO_HERO from '../../images/videos/final render.mp4';
import VIDEO_SHOWCASE from '../../images/videos/final.mp4';
import VIDEO__SIDE_SHOWCASE from '../../images/videos/videoblocks-od13437-hd_hdmrrbkmn_1080__D.mp4';

// STYLES (external CSS from previous message)
import '../../css/style.css';

export class Home extends Component {
  constructor(props){
  super(props);
  this.rootRef = React.createRef();
  this.state = { activeFilter: 'all' };
}
setActiveFilter = (filter) => { this.setState({ activeFilter: (filter||'all').toLowerCase() }); };
matchesFilter = (category) => {
  const { activeFilter } = this.state;
  if (activeFilter === 'all') return true;
  return (category || '').toLowerCase() === activeFilter;
};

  render() {
    return (
      <Fragment>
        <div className="page-wrap" ref={this.rootRef}>
          {/* HERO */}
          <section className="hero" aria-label="Intro video hero">
            <video autoPlay muted loop playsInline className="hero-video" aria-hidden="true">
              <source src={VIDEO_HERO} type="video/mp4" />
            </video>
            <div className="hero-overlay" aria-hidden="true"></div>
            <div className="hero-content">
              <h1>ELITE SPORTS KITS</h1>
              <p>Premium athletic wear engineered for champions. Custom designs, pro-grade materials, and unbeatable performance.</p>
              <div className="cta-bar">
                <a href="#shop" className="btn btn-primary">Shop Collection</a>
                <a href="#customize" className="btn btn-ghost">Customize Kit</a>
              </div>
            </div>
          </section>

          {/* SPORTS BANNER */}
          <section className="sports-banner">
            <div className="sport-banner-item">
              <div className="sport-icon">⚽</div>
              <h3>Soccer Kits</h3>
              <p>Professional-grade jerseys with advanced moisture-wicking technology</p>
            </div>
            <div className="sport-banner-item">
              <div className="sport-icon">🏏</div>
              <h3>Cricket Gear</h3>
              <p>Performance wear designed for long matches and maximum comfort</p>
            </div>
            <div className="sport-banner-item">
              <div className="sport-icon">🏀</div>
              <h3>Basketball Uniforms</h3>
              <p>Breathable fabrics with dynamic fit for court domination</p>
            </div>
            <div className="sport-banner-item">
              <div className="sport-icon">🎽</div>
              <h3>Casual Wear</h3>
              <p>Complete Casual  kits for practice sessions and gym workouts</p>
            </div>
          </section>

          {/* STATIC KIT BANNER */}
          <section className="static-kit-banner">
            <img src={IMG_CONNECT} alt="Premium Sports Kits Collection" className="static-kit-image" />
            <div className="static-kit-overlay overlay-shift-25rem">
              <div className="static-kit-content">
                <a href="#shop" className="btn btn-primary big-btn">Explore Collection</a>
              </div>
            </div>
          </section>

          {/* STATS */}
          <section className="stats-section">
            <div className="section-header center">
              <h2>Why Teams Choose Us</h2>
            </div>
            <div className="stats-grid">
              <div className="stat-item">
                <h3>500+</h3>
                <p>Teams Outfitted</p>
              </div>
              <div className="stat-item">
                <h3>98%</h3>
                <p>Customer Satisfaction</p>
              </div>
              <div className="stat-item">
                <h3>24/7</h3>
                <p>Support Available</p>
              </div>
              <div className="stat-item">
                <h3>5-7 Days</h3>
                <p>Average Delivery</p>
              </div>
            </div>
          </section>

       {/* SHOP FILTER + GRID */}
<section className="section" id="shop">
  <div className="section-header">
    <h2>Browse Kits</h2>
    <div className="pillbar" role="tablist" aria-label="Filter kits by sport">
      {/* note: onClick + active class + aria-selected */}
      <button
        className={`pill ${this.state.activeFilter === 'all' ? 'active' : ''}`}
        onClick={() => this.setActiveFilter('all')}
        aria-selected={this.state.activeFilter === 'all'}
      >
        All
      </button>
      <button
        className={`pill ${this.state.activeFilter === 't-shirts' ? 'active' : ''}`}
        onClick={() => this.setActiveFilter('T-Shirts')}
        aria-selected={this.state.activeFilter === 't-shirts'}
      >
        T-Shirts
      </button>
      <button
        className={`pill ${this.state.activeFilter === 'women kit' ? 'active' : ''}`}
        onClick={() => this.setActiveFilter('Women Kit')}
        aria-selected={this.state.activeFilter === 'women kit'}
      >
        Gym Kit
      </button>
      <button
        className={`pill ${this.state.activeFilter === 'joggers' ? 'active' : ''}`}
        onClick={() => this.setActiveFilter('Joggers')}
        aria-selected={this.state.activeFilter === 'joggers'}
      >
        Joggers
      </button>
    </div>
  </div>

  <div className="grid" id="products">
    {/* T-Shirts */}
    <article
      className="card"
      data-sport="T-Shirts"
      style={{ display: this.matchesFilter('T-Shirts') ? 'block' : 'none' }}
    >
      <img src={IMG_SOCCER_NEO} alt="Neo Strike t-shirt Kit" className="thumb" />
      <div className="card-body">
        <div className="meta"><span className="tag">T-Shirts</span><span className="price">$59</span></div>
        <h3 className="title">Neo Strike Jersey</h3>
        <p className="muted-600 small">Breathable mesh, moisture-wicking, match-ready fit with enhanced mobility.</p>
        <div className="add"><button className="btn-cart" data-name="Neo Strike Jersey">Add to Cart</button></div>
      </div>
    </article>

    {/* Women Kit */}
    <article
      className="card"
      data-sport="Women Kit"
      style={{ display: this.matchesFilter('Women Kit') ? 'block' : 'none' }}
    >
      <img src={IMG_BASKETBALL_ELEVATE} alt="Elevate woman Kit" className="thumb" />
      <div className="card-body">
        <div className="meta"><span className="tag">Gym Kit</span><span className="price">$58</span></div>
        <h3 className="title">Elevate Court</h3>
        <p className="muted-600 small">Pro-cut armholes and quick-dry side vents for maximum court performance.</p>
        <div className="add"><button className="btn-cart" data-name="Elevate Court">Add to Cart</button></div>
      </div>
    </article>

    {/* T-Shirts (second) */}
    <article
      className="card"
      data-sport="T-Shirts"
      style={{ display: this.matchesFilter('T-Shirts') ? 'block' : 'none' }}
    >
      <img src={IMG_CRICKET_POWERPLAY} alt="Powerplay t-shirt Kit" className="thumb" style={{ height: '18rem' }} />
      <div className="card-body">
        <div className="meta"><span className="tag">T-Shirts</span><span className="price">$64</span></div>
        <h3 className="title">Powerplay Pro</h3>
        <p className="muted-600 small">Lightweight fabric with reinforced seams for 50-overs and superior comfort.</p>
        <div className="add"><button className="btn-cart" data-name="Powerplay Pro">Add to Cart</button></div>
      </div>
    </article>

    {/* Joggers */}
    <article
      className="card"
      data-sport="Joggers"
      style={{ display: this.matchesFilter('Joggers') ? 'block' : 'none' }}
    >
      <img src={IMG_GOALKEEPER_VOLT} alt="Volt Fusion joggers Kit" className="thumb volt-image-fix" />
      <div className="card-body">
        <div className="meta"><span className="tag">Joggers</span><span className="price">$62</span></div>
        <h3 className="title">Volt Fusion</h3>
        <p className="muted-600 small">Heat-bonded stripes with anti-chafe collar for 90-minute comfort.</p>
        <div className="add"><button className="btn-cart" data-name="Volt Fusion">Add to Cart</button></div>
      </div>
    </article>
  </div>
</section>


          {/* PROMO BANNER */}
          <section className="promotion-banner">
            <div className="promotion-content">
              <h2>Limited Time Offer</h2>
              <p>Get 20% off on all custom team kits ordered before the season starts. Don't miss this exclusive deal!</p>
              <div className="countdown">
                <div className="countdown-item">
                  <span className="countdown-number" id="days">12</span>
                  <span className="countdown-label">Days</span>
                </div>
                <div className="countdown-item">
                  <span className="countdown-number" id="hours">18</span>
                  <span className="countdown-label">Hours</span>
                </div>
                <div className="countdown-item">
                  <span className="countdown-number" id="minutes">45</span>
                  <span className="countdown-label">Minutes</span>
                </div>
                <div className="countdown-item">
                  <span className="countdown-number" id="seconds">30</span>
                  <span className="countdown-label">Seconds</span>
                </div>
              </div>
              <a href="#customize" className="btn btn-primary">Customize Now & Save</a>
            </div>
          </section>

          {/* FEATURES */}
          <section className="features-section">
            <div className="section-header">
              <h2>Why Choose Our Sports Kits?</h2>
              <p className="muted-600 max-600">
                We combine premium materials with cutting-edge design to deliver performance-enhancing sportswear
              </p>
            </div>
            <div className="features-grid">
              <div className="feature-card">
                <div className="feature-icon">🔬</div>
                <h3>Advanced Fabric Technology</h3>
                <p>Our proprietary moisture-wicking fabrics keep players dry and comfortable even during intense matches.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">✂️</div>
                <h3>Precision Tailoring</h3>
                <p>Every kit is designed with athlete-specific cuts for maximum mobility without compromising on style.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">🎨</div>
                <h3>Custom Design Studio</h3>
                <p>Create your unique team identity with our easy-to-use online customizer and design tools.</p>
              </div>
            </div>
          </section>

          {/* GALLERY */}
          <section className="gallery-section">
            <div className="section-header">
              <h2>In Action Gallery</h2>
              <p className="muted-600 max-600">
                See how our kits perform on the field, court, and pitch with teams around the world
              </p>
            </div>
            <div className="gallery-grid">
              <div className="gallery-item">
                <img src={GAL_IMG_1} alt="Soccer team in action" className="gallery-img" />
                <div className="gallery-overlay">
                  <h3>United Strikers FC</h3>
                  <p>Regional Champions 2023</p>
                </div>
              </div>
              <div className="gallery-item">
                <img src={GAL_IMG_2} alt="Cricket team celebration" className="gallery-img" />
                <div className="gallery-overlay">
                  <h3>Lightning Cricket Club</h3>
                  <p>National Tournament Winners</p>
                </div>
              </div>
              <div className="gallery-item">
                <img src={GAL_IMG_3} alt="Basketball team huddle" className="gallery-img" />
                <div className="gallery-overlay">
                  <h3>Sky Dunkers</h3>
                  <p>City League Champions</p>
                </div>
              </div>
              <div className="gallery-item">
                <img src={GAL_IMG_4} alt="Team training session" className="gallery-img" />
                <div className="gallery-overlay">
                  <h3>Training Session</h3>
                  <p>Practice in comfort and style</p>
                </div>
              </div>
            </div>
          </section>

          {/* VIDEO SHOWCASE */}
          <section className="video-showcase">
            <div className="video-container">
              <video autoPlay muted loop playsInline className="showcase-video">
                <source src={VIDEO_SHOWCASE} type="video/mp4" />
              </video>
            </div>
          </section>

          {/* TEAMS */}
          <section className="teams-section">
            <div className="section-header">
              <h2>Powered by Connect</h2>
              <p className="muted-600 max-600">
                Join the ranks of championship-winning teams who trust us with their kits
              </p>
            </div>
            <div className="teams-grid">
              <div className="team-card">
                <div className="team-logo">FC</div>
                <h3 className="team-name">Falcon Chargers</h3>
                <div className="team-sport">Soccer Club</div>
                <p className="team-desc">Regional champions 2023 with our custom performance kits</p>
              </div>
              <div className="team-card">
                <div className="team-logo">TB</div>
                <h3 className="team-name">Thunder Bolts</h3>
                <div className="team-sport">Cricket Academy</div>
                <p className="team-desc">National youth tournament winners in our custom gear</p>
              </div>
              <div className="team-card">
                <div className="team-logo">HJ</div>
                <h3 className="team-name">High Jumpers</h3>
                <div className="team-sport">Basketball Team</div>
                <p className="team-desc">City league champions with our breathable court uniforms</p>
              </div>
            </div>
          </section>

          {/* CUSTOMIZE */}
          <section className="section" id="customize">
            <div className="customize">
              <div>
                <h3>Create Your Custom Kit</h3>
                <p>
                  Design the ultimate team uniform with our advanced customizer. Pick base colors, add stripes/patterns,
                  upload logos & numbers — preview in real-time and export your order.
                </p>
                <div className="steps">
                  <div className="step"><span className="dot">1</span> Choose sport, base color & size range</div>
                  <div className="step"><span className="dot">2</span> Apply collar/sleeve/trouser styles and patterns</div>
                  <div className="step"><span className="dot">3</span> Upload team logo, sponsor, name & numbers</div>
                  <div className="step"><span className="dot">4</span> Generate mockup & add to cart</div>
                </div>
                <a href="#!" className="btn btn-primary inline-btn">Launch Customizer</a>
               <div className="badges"  style={{    display: "flex",    gap: "10px",    justifyContent: "center",    alignItems: "center",   flexWrap: "wrap",   background: "rgba(255, 255, 255, 0.1)",   backdropFilter: "blur(10px)",   WebkitBackdropFilter: "blur(10px)",    borderRadius: "20px",  padding: "10px 20px",   border: "1px solid rgba(255, 255, 255, 0.2)",  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)" , marginTop: "1rem" }}>
  <div
    className="badge"
    style={{
      color: "#fff",
      fontWeight: "500",
      fontSize: "14px",
      background: "rgba(255, 255, 255, 0.15)",
      borderRadius: "12px",
      padding: "6px 14px",
      backdropFilter: "blur(6px)",
      WebkitBackdropFilter: "blur(6px)",
      border: "1px solid rgba(255, 255, 255, 0.25)",
    }}
  >
    ⚡ Live Preview
  </div>
  <div
    className="badge"
    style={{
      color: "#fff",
      fontWeight: "500",
      fontSize: "14px",
      background: "rgba(255, 255, 255, 0.15)",
      borderRadius: "12px",
      padding: "6px 14px",
      backdropFilter: "blur(6px)",
      WebkitBackdropFilter: "blur(6px)",
      border: "1px solid rgba(255, 255, 255, 0.25)",
    }}
  >
    📦 7-10 Day Dispatch
  </div>
  <div
    className="badge"
    style={{
      color: "#fff",
      fontWeight: "500",
      fontSize: "14px",
      background: "rgba(255, 255, 255, 0.15)",
      borderRadius: "12px",
      padding: "6px 14px",
      backdropFilter: "blur(6px)",
      WebkitBackdropFilter: "blur(6px)",
      border: "1px solid rgba(255, 255, 255, 0.25)",
    }}
  >
    🧼 Wash-Safe Prints
  </div>
  <div
    className="badge"
    style={{
      color: "#fff",
      fontWeight: "500",
      fontSize: "14px",
      background: "rgba(255, 255, 255, 0.15)",
      borderRadius: "12px",
      padding: "6px 14px",
      backdropFilter: "blur(6px)",
      WebkitBackdropFilter: "blur(6px)",
      border: "1px solid rgba(255, 255, 255, 0.25)",
    }}
  >
    🇺🇸 Made in USA
  </div>
</div>

              </div>
              <div className="customizer-video">
                <video autoPlay muted loop playsInline className="showcase-video">
                  <source src={VIDEO__SIDE_SHOWCASE} type="video/mp4" />
                </video>
              </div>
            </div>
          </section>

          {/* NEWSLETTER */}
          <section className="newsletter">
            <h3>Stay in the Game</h3>
            <p>Subscribe to our newsletter for exclusive deals, new kit releases, and sports tips from pros.</p>
            <form className="newsletter-form">
              <input type="email" className="newsletter-input" placeholder="Enter your email" required />
              <button type="submit" className="btn btn-primary">Subscribe</button>
            </form>
          </section>
        </div>
      </Fragment>
    );
  }
}

export default Home;
